import React from "react"
import cCStyle from "./CardsContainer.module.css"
import Card from "./Card"
import data from "./content"

export default function CardsContainer() {
  return (
    <div className={cCStyle.cardsContainer}>
      {data.map((element, index) => {
        return <Card key={`Card-${index}`} propsData={element} />
      })}
    </div>
  )
}
